<template>
  <div class="bottomPannel">
    <el-tabs
      style="height: 100%; width: 100%"
      class="bottomPannel-tabls"
      v-model="activeName"
      @tab-click="handleClick"
    >
      <!-- 水位站 -->
      <el-tab-pane label="水位站" name="first">
        <div class="bottomPannel-charts">
          <echartBox style="width: 100%; height: 100%" :option="waterOption" />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script lang="ts" setup>
import { createApp, h, ref } from 'vue'
import type { TabsPaneContext } from 'element-plus'
import type { EChartsOption } from 'echarts'
import * as echarts from 'echarts'
import echartBox from '@/components/EchartBox/echart-box.vue'

import { waterStationList } from './staticData'
import PannelEchartTooltip from './PannelEchartTooltip.vue'
// 当前日期
const now = new Date()
const year = now.getFullYear()
const month = String(now.getMonth() + 1).padStart(2, '0')
const day = String(now.getDate()).padStart(2, '0')
const hours = String(now.getHours()).padStart(2, '0')
const minutes = String(now.getMinutes()).padStart(2, '0')
const seconds = String(now.getSeconds()).padStart(2, '0')

/**横坐标 */
const xAxis = ref<number[]>([])
const yAxis = ref<number[]>([])

const getAxis = () => {
  xAxis.value = waterStationList.map((item) => item.lcwz)
  yAxis.value = waterStationList.map((item) => item.clsw)
}
const activeName = ref('first')
const handleClick = (tab: TabsPaneContext, event: Event) => {
  console.log(tab, event)
}
const waterOption: EChartsOption = {
  title: {
    text: `日期：${year}-${month}-${day} ${hours}:${minutes}:${seconds}`,
    textStyle: {
      fontSize: 13,
    },
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
    formatter(v: echarts.TooltipComponentFormatterCallbackParams) {
      console.log(v)
      if (!Array.isArray(v)) return ''
      const input = v
        .map((el) => {
          return `<div> <span>${el.name}</span><br/>
            <span>2025-04-11 14:00</span><br/>
            ${el.marker}<span>水位：${el.value}米</span><br/>
          </div>`
        })
        .join('')
      const resHtml = `<div>
      ${input}
      </div>`
      return resHtml
    },
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: 0,
    containLabel: true,
  },
  xAxis: [
    {
      type: 'category',
      data: [
        '水口坝下',
        '溪口大桥(河道)',
        '金沙闸(上)',
        '白沙(上)',
        '竹岐w',
        '城关站(上)',
        '文山里w',
        '陈厝(上)',
        '营前闸内',
      ],
      axisTick: {
        alignWithLabel: true,
      },
    },
  ],
  yAxis: [
    {
      type: 'value',
    },
  ],
  series: [
    {
      name: '水位',
      type: 'bar',
      barWidth: '100%',
      data: [12.03, 3.63, 5.54, 4.23, 2.44, 2.61, 2.49, 1.4, 3.51],
      label: {
        show: true,
        position: 'top',
        color: '#333', // 数值颜色
        fontSize: 12, // 字体大小
        fontWeight: 'bold', // 加粗
      },
      itemStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: '#83bff6' }, // 顶部颜色
          { offset: 1, color: '#188df0' }, // 底部颜色
        ]),
      },
    },
  ],
}
getAxis()

const getList = () => {}

defineExpose({
  getList,
})
</script>

<style lang="scss" scoped>
.bottomPannel {
  height: 100%;
  width: 100%;
  &-data {
    font-size: 12px;
    height: 20px;
  }
  &-charts {
    height: 95%;
    width: 100%;
  }
}
:deep(.el-tab-pane)  {
  height: 100%;
  display: flex;
  flex-direction: column;
}
:deep(.el-tabs__nav) {
  width: 300px;
  display: flex;
}
:deep(.el-tabs__item) {
  flex: 1;
  font-size: 16px;
}

</style>
